class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.categoryButtons = this.querySelectorAll('.faq-section__category-btn');
    this.categorySelect = this.querySelector('.faq-section__category-select');
    this.faqItems = this.querySelectorAll('.faq-section__item');
    this.content = this.querySelector('.faq-section__items');
    
    this.initializeEventListeners();
    this.showCategory(0);
  }

  initializeEventListeners() {
    this.categoryButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.showCategory(index);
        this.updateActiveButton(button);
      });
    });

    this.categorySelect?.addEventListener('change', (event) => {
      const index = event.target.selectedIndex;
      this.showCategory(index);
    });
  }

  showCategory(categoryIndex) {
    let currentCategory;

    if (this.categorySelect.options[0].selected) {
      currentCategory = -1;
    } else {
      currentCategory = 0;
    }
    let isInSelectedCategory = false;

    Array.from(this.content.children).forEach(element => {
      if (element.classList.contains('faq-section__category')) {
        currentCategory++;
        isInSelectedCategory = (currentCategory === categoryIndex);
      } else if (element.classList.contains('faq-section__item') || element.classList.contains('faq-section__category-label')) {
        element.classList.toggle('is-visible', isInSelectedCategory);
      }
    });
  }

  updateActiveButton(activeButton) {
    this.categoryButtons.forEach(button => {
      button.classList.toggle('is-active', button === activeButton);
    });
  }
}

customElements.define('faq-section', FAQSection); 